var $5f3754867e416768$exports = {};
$5f3754867e416768$exports = {
    "backButton": (args)=>`Atgriezties uz ${args.prevMenuButton}`,
    "moreActions": `Citas darb\u{12B}bas`,
    "unavailable": `Nav pieejams, izv\u{113}rsiet, lai skat\u{12B}tu s\u{12B}k\u{101}ku inform\u{101}ciju`
};


export {$5f3754867e416768$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
